<template>
  <div id="app">
    <div class="main">
      <div class="main-header">
        <a href="https://autoverify.com/" target="_blank" class="av-logo">
          <img alt="AutoVerify" src="./assets/img/logo.svg" />
        </a>
        <img class="mobile-header-img" alt="" src="./assets/img/mobile-header.svg" />
        <img class="tablet-header-img" alt="" src="./assets/img/tablet-header.png" />
        <img class="header-img" alt="" src="./assets/img/header.svg" />
      </div>
      <div class="main-body">
        <div class="main-body-inner">
          <div v-if="isLoading" class="my-5">
            <div class="spinner spinner-border text-primary my-5" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-else>
            <router-view />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import router from './router';

export default {
  name: 'App',
  computed: mapState({
    isLoading: state => state.isLoading,
  }),
  beforeCreate() {
    if (this.$route.query.id) {
      this.$store.dispatch('getData', this.$route.query.id);
    } else {
      router.push('/error').catch(() => {});
    }
    if (this.$route.query.language) {
      this.$i18n.locale = this.$route.query.language || 'en_CA';
    }
  },
};
</script>

<style lang="scss" scoped>
.spinner {
  width: 3rem;
  height: 3rem;
}
</style>
